import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import { useChangeTrailerMutation, useLazyGetTrailerDetailQuery } from '../../api/trailer';
import { TrailerForm } from '../../components/TrailerForm';
import { TrailerEdit } from '../../Trailer.entity';

type Props = {
  id: number;
  onRefresh: () => void;
};

const INITIAL_FORM: TrailerEdit = {
  id: 0,
  number: '',
};

export const EditTrailerModal: FC<Props> = ({ id, onRefresh }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<TrailerEdit>(INITIAL_FORM);

  const [changeTrailer, { isLoading }] = useChangeTrailerMutation();
  const [getTrailerDetail] = useLazyGetTrailerDetailQuery();

  const getInitData = useCallback(async () => {
    getTrailerDetail({ id }).then((data) => {
      if (isSuccess(data)) {
        data?.data && setForm(data.data);
      }
    });
  }, [getTrailerDetail, id]);

  useEffect(() => {
    getInitData();
  }, [getInitData]);

  const handleChange = (name: keyof TrailerEdit, value: TrailerEdit[keyof TrailerEdit]) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    changeTrailer(form).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Прицеп успешно обновлен', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Редактирование прицепа"
      visible
      isLoadingSubmit={isLoading}
      width={500}
      height="auto"
      textConfirm="Сохранить"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <TrailerForm form={form} onChange={handleChange} />
    </ModalForm>
  );
};

export default EditTrailerModal;
